import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "@/i18n";
import { Reveal, LineMask } from "@/components/Reveal";

const Method = () => {
  const { t } = useLang();
  const [active, setActive] = useState(0);
  const state = t.method.states[active];

  return (
    <section className="method section-light" id="metodo" aria-labelledby="method-title" data-testid="method-section">
      <div className="shell">
        <div className="section-heading">
          <Reveal className="section-index dark" aria-hidden="true">{t.method.index}</Reveal>
          <div>
            <Reveal><p className="kicker dark">{t.method.kicker}</p></Reveal>
            <h2 id="method-title" className="display-title dark">
              <LineMask delay={0.1}>{t.method.titleA}</LineMask>
              <LineMask delay={0.22}><span>{t.method.titleB}</span></LineMask>
            </h2>
          </div>
        </div>

        <div className="method-grid">
          <div className="steps" role="tablist" aria-label={t.method.kicker}>
            {t.method.steps.map((step, i) => (
              <Reveal key={step.title} delay={i * 0.07}>
                <button
                  className={`step ${active === i ? "active" : ""}`}
                  type="button"
                  role="tab"
                  aria-selected={active === i}
                  onClick={() => setActive(i)}
                  data-testid={`method-step-${i}`}
                >
                  <span className="step-number">{String(i + 1).padStart(2, "0")}</span>
                  <span className="step-copy">
                    <strong>{step.title}</strong>
                    <small>{step.desc}</small>
                  </span>
                  <span className="step-arrow" aria-hidden="true">↗</span>
                </button>
              </Reveal>
            ))}
          </div>

          <Reveal className="phone-stage" delay={0.15}>
            <div className="orbit orbit-one" aria-hidden="true"></div>
            <div className="orbit orbit-two" aria-hidden="true"></div>
            <div className="phone" aria-label={t.method.phoneLabel} data-testid="phone-mockup">
              <div className="phone-top"><span>9:41</span><span className="phone-island"></span><span>●</span></div>
              <AnimatePresence mode="wait">
                <motion.div
                  key={`${active}-${state.title}`}
                  initial={{ opacity: 0, y: 14 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.35 }}
                >
                  <div className="app-header">
                    <div>
                      <small>{state.kicker}</small>
                      <h3>{state.title}</h3>
                    </div>
                    <button className="avatar" type="button" aria-label="Profilo">GM</button>
                  </div>
                  <div className="workout-visual">
                    <div className="workout-ring"><span>{state.ring[0]}</span><small>{state.ring[1]}</small></div>
                    <div className="workout-tags">{state.tags.map((tg) => <span key={tg}>{tg}</span>)}</div>
                  </div>
                  <div className="exercise-list">
                    {state.rows.map(([num, name, sub, icon]) => (
                      <div key={num + name}>
                        <span>{num}</span>
                        <p><strong>{name}</strong><small>{sub}</small></p>
                        <b>{icon}</b>
                      </div>
                    ))}
                  </div>
                  <div className="coach-note">
                    <span>{state.note[0]}</span>
                    <p>{state.note[1]}</p>
                  </div>
                </motion.div>
              </AnimatePresence>
              <div className="app-nav" aria-hidden="true"><b>⌂</b><span>◫</span><span>◎</span><span>◌</span></div>
            </div>
            <span className="floating-tag tag-one">{t.method.floatOne} <b>✓</b></span>
            <span className="floating-tag tag-two">Streak <b>{t.method.floatTwo}</b></span>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Method;
